/**
 * Created by roman.kupin on 9/28/2017.
 */

import * as AccountApiActions from "../../actions/accountApi";


export default function accountOverviewReducer(state = {}, {type, payload}) {
    switch (type) {
        case AccountApiActions.OVERVIEW_FETCH_SUCCESS: {
            return Object.assign({}, payload);
        }
        default: {
            return state;
        }
    }
}